<template>
  <!-- 签署借款合同 -->
  <div>
    <ul>
      <component
        v-for="(item, index) in elementData[0].components"
        :key="index"
        :is="item.component"
        :dataInfo="item"
        :pageData="pageData"
      ></component>

      <contract-full
        @getBtnStatus="getBtnStatus"
        :list="elementData[0].contracts"
        :pageData="pageData"
      ></contract-full>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :disabled="isDisabled"
      :click="submitContract"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Button from '@/components/Button.vue';
import ContractInfo from '@/components/ContractInfo.vue';
import ContractFull from '@/components/ContractFull.vue';
import ServerBank from '@/components/ServerBank.vue';
import { Toast } from 'vant';
import PopupField from './components/PopupField.vue';

export default {
  name: 'signLoanContractStandard',
  data() {
    return {
      danger: 'danger',
      draw: '确认签署',
      // 动态渲染组件 - 非可编辑
      elementData: [{}],
      isDisabled: false,
      pageData: {},
    };
  },
  components: {
    Button,
    ContractInfo,
    ContractFull,
    ServerBank,
    PopupField,
  },
  computed: {
    ...mapState({
      otherPages(val) {
        for (const i in this.elementData.components) {
          this.$set(this.elementData.components[i], 'value', val.otherPages.creditContractObj[this.elementData.components[i].key]);
        }
        return val.otherPages;
      },
    }),
  },
  watch: {
    otherPages: { // 监听事件勿删
      handler(newval) {
      },
    },
  },
  mounted() {
    this.getPageConfig();
  },
  methods: {
    // 获取合同页配置
    getPageConfig() {
      // this.elementData = [{
      //   components: [
      //     {
      //       component: 'contractInfo',
      //       label: '借据号',
      //       key: 'lend_acct_no',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '合作平台名称',
      //       key: 'plat_name',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款用途',
      //       key: 'loan_purpose_cn',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款金额（大写）',
      //       key: 'loan_amt_cn',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款期限',
      //       key: 'loan_exp',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款起始日期',
      //       key: 'loan_start_date',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款到期日期',
      //       key: 'loan_end_date',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '贷款年利率',
      //       key: 'exec_rate',
      //       lastUnit: '%',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '担保金费率',
      //       key: 'securityRate',
      //       lastUnit: '%',
      //     },
      //     {
      //       component: 'PopupField',
      //       label: '担保金金额',
      //       key: 'securityAmount',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '支付方式',
      //       key: 'paymentType',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '放款账户户名',
      //       key: 'custName',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '开户网点名称',
      //       key: 'loanBankName',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '放款账号',
      //       key: 'loanBankNo',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '开户行行名',
      //       key: 'openBankName',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '开户行行号',
      //       key: 'openBankNo',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '现代支付号',
      //       key: 'paymentNo',
      //       inShowField: 'paymentType',
      //       condition: '受托支付',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '还款方式',
      //       key: 'repay_type_name',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '还款银行名称',
      //       key: 'repay_bank_name',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '还款账号',
      //       key: 'repay_acct_no',
      //     },
      //     {
      //       component: 'contractInfo',
      //       label: '还款户名',
      //       key: 'repay_acct_name',
      //     },
      //   ],
      //   contracts: [
      //     {
      //       text: '浦银快贷个人借款合同',
      //       value: 'PufaPdf',
      //     },
      //   ],
      // }];
      // this.getContractInfo();

      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res.success) {
          const result = JSON.parse(res.data[0].productConfigs);
          localStorage.setItem('configData', res.data[0].productConfigs);
          this.elementData = [...result];

          this.getContractInfo();
        }
        this.$toast.clear();
      });
    },
    // 查询合同信息
    async getContractInfo() {
      const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo({
        orderId: this.$route.query.orderId,
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
      });
      if (!success) {
        this.$toast(returnMessage || '获取数据失败');
        return;
      }
      this.pageData = data;
      for (const i in this.elementData[0].components) {
        this.$set(this.elementData[0].components[i], 'value', data[this.elementData[0].components[i].key]);
      }
    },
    // 合同签署
    async submitContract() {
      try {
        this.$loading.show('合同签署中...');
        const { success, returnMessage } = await this.$api.OtherPage.commitApply({
          orderId: this.$route.query.orderId,
          pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
        });
        this.$loading.hide();
        if (success) {
          if (this.pageData.jumpUrl) {
            window.location.href = this.pageData.jumpUrl;
            return;
          }
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          Toast(returnMessage);

          setTimeout(() => {
            this.$store.dispatch('otherPages/jumpCurrPageServer');
          }, 2000);
        }
      } catch (e) {
        Toast('签署合同失败');
      }
    },
    getBtnStatus(val) {
      this.isDisabled = !val;
    },
  },
};
</script>
<style scoped>
.popupStyle {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}
.nextStep {
  margin-top: 100px;
  /* margin-bottom: 12px; */
}
.contractDraw {
  width: 92%;
  height: 40px;
  margin: auto;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
</style>
